import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Loading from '@/views/Loading.vue';
import {Logger} from '@vanti/vue-logger';

Vue.use(VueRouter);

const log = Logger.get('router');

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'loading',
      component: Loading
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
});

// force the /login page if the app isn't authenticated.
router.beforeEach((to, from, next) => {
  log.debug('to: ', to);

  if (store.getters['auth/authLoaded'] && !store.getters['auth/isAuthenticated']) {
    if (to.name === 'login') {
      return next();
    }
    return next({name: 'login', params: {force: false, redirect: to}});
  }

  if (!store.getters['loading/appLoaded']) {
    if (to.name === 'loading') {
      return next();
    }
    return next({name: 'loading', params: {force: false, redirect: to}});
  }


  // if (!store.getters['loading/appLoaded']) {
  //   if (to.name === 'loading' || to.name === 'graphlogin') {
  //     return next();
  //   }
  //   return next({name: 'loading', params: {force: false, redirect: to}, query: to.query});
  // }

  return next();
});

export default router;
